import { SceneBase } from '@jollywise/jollygoodgame';
import { ButtonClimateChampions } from '../../display/ui/ButtonClimateChampions';
import { FONT_BASE } from '../../constants/AppFonts';
import { EndScreen } from './EndScreen';
import PlayerModel from '../../state/PlayerModel';

export default class GameSceneBase extends SceneBase {
  constructor(config) {
    super(config);

    this.id = config.key;
  }

  create() {
    super.create();
    this.game.hud.setState('GAME');
    this.setBackground('background_level');
  }

  restartGame() {
    console.log('restartGame should be overwritten by the game class');
  }

  showInstruction(instruction, callback, callbackScope) {
    // const stars = this.game.model.getStars(this.id);
    // if (stars !== 0) {
    //   callback.call(callbackScope);
    // } else {
    const container = this.add.container();
    const panel = this.add
      .image(0, 50, 'howtoplay', 'instruction_bg')
      .setScale(0.65)
      .setOrigin(0.5);
    const text = this.add
      .text(0, 49, instruction, {
        font: `24px ${FONT_BASE.COPY}`,
        color: '#000000',
        align: 'center',
        wordWrap: { width: 550 },
      })
      .setOrigin(0.5);
    const close = new ButtonClimateChampions(this, {
      x: 300,
      costume: 'btn_close',
    });
    container.add([panel, text, close]);
    container.x = 840;
    container.y = -720;
    this.tweens.add({
      targets: container,
      y: 150,
      duration: 500,
    });
    close.once('click', () => {
      this.tweens.add({
        targets: container,
        y: -750,
        duration: 500,
        onComplete: container.destroy,
        onCompleteScope: container,
      });
      callback.call(callbackScope);
    });
  }

  // =============================================================================================
  // END SCREEN MANAGEMENT
  // =============================================================================================

  showEndGameScreen(win, stars) {
    this.game.model.setStars(this.id, stars);
    this.endScreen = new EndScreen(this, { gameid: this.id, win, stars });
    this.endScreen.on('CONTINUE', this._handleEndScreenContinue, this);
    this.endScreen.on('RESTART', this._handleEndScreenRestart, this);
    this.children.bringToTop(this.endScreen);
  }

  clearEndGameScreen() {
    if (!this.endScreen) return;
    this.endScreen.destroy();
    this.endScreen = null;
  }

  _handleEndScreenContinue() {
    this.clearEndGameScreen();
    this.game.showLevelSelect();
  }

  _handleEndScreenRestart() {
    this.clearEndGameScreen();
    this.restartGame();
  }

  // CLEAN UP

  shutdown() {
    this.clearEndGameScreen();
    this.time.removeAllEvents();
    super.shutdown();
  }
}
